export const selectAdverts = state => state.adverts.advertsList; 
export const isLast = state => state.adverts.isLast; 
export const selectFavorites = state => state.adverts.favorites;
export const selectBooked = state => state.adverts.booked;
export const selectFetchLoading = state => state.adverts.isFetchLoading;
export const selectFetchError = state => state.adverts.fetchError; 
 